import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Check, Clock, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import * as styles from './styles';
import { TransactionStatusBackend } from '../../contents/PaymentStatusStep/types';
import { TransactionStatusProps } from './interfaces';

const STATUS_UI: Record<
  TransactionStatusBackend,
  { textKey: string; bgColor: string; icon: React.ReactNode | null }
> = {
  COMPLETED: { textKey: 'STATUSES.TRANSACTION_COMPLETED', bgColor: '#354EEF', icon: <Check size={20} color="#fff" /> },
  PENDING: { textKey: 'STATUSES.TRANSACTION_PROCESSING', bgColor: '#F5A623', icon: <Clock size={20} color="#fff" /> },
  PAYOUT_EXECUTED: { textKey: 'STATUSES.TRANSACTION_PROCESSING', bgColor: '#F5A623', icon: <Clock size={20} color="#fff" /> },
  AWAITING_PLATFORM: { textKey: 'STATUSES.TRANSACTION_PROCESSING', bgColor: '#F5A623', icon: <Clock size={20} color="#fff" /> },
  FAILED: { textKey: 'STATUSES.TRANSACTION_DECLINED', bgColor: '#E74C3C', icon: <X size={20} color="#fff" /> },
  CANCELLED: { textKey: 'STATUSES.TRANSACTION_DECLINED', bgColor: '#E74C3C', icon: <X size={20} color="#fff" /> },
  ERROR: { textKey: 'STATUSES.TRANSACTION_DECLINED', bgColor: '#E74C3C', icon: <X size={20} color="#fff" /> },
  EXPIRED: { textKey: 'STATUSES.TRANSACTION_DECLINED', bgColor: '#E74C3C', icon: <X size={20} color="#fff" /> },
  REJECTED: { textKey: 'STATUSES.TRANSACTION_DECLINED', bgColor: '#E74C3C', icon: <X size={20} color="#fff" /> },
};

const TransactionStatus: React.FC<TransactionStatusProps> = ({ status }) => {
  const { t } = useTranslation('paymentModal');
  const config = STATUS_UI[status];

  return (
    <Stack sx={styles.rootSx}>
      <Box sx={styles.iconWrapperSx(config.bgColor)}>{config.icon}</Box>
      <Typography sx={styles.textSx}>{t(config.textKey)}</Typography>
    </Stack>
  );
};

export default TransactionStatus;
